import React, { useEffect } from "react";
const Counter = () => {
  useEffect(() => {
    // Visitor counter script 1
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src = `https://www.freevisitorcounters.com/auth.php?id=${process.env.REACT_APP_COUNTER_KEY}}`;
    //Visitor counter reset on dev 05-12-2025
    document.body.appendChild(script1);

    // Visitor counter script 2
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = `https://www.freevisitorcounters.com/en/home/counter/${process.env.REACT_APP_COUNTER_ID}/t/5`;
    document.body.appendChild(script2);

    return () => {
      // Clean up scripts if needed
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);
  return (
    <React.Fragment>
      <img
        src={`https://www.freevisitorcounters.com/en/counter/render/${process.env.REACT_APP_COUNTER_ID}/t/5`}
        alt="Free visitor counter"
        style={{ border: 0 }}
        className="counterimg"
      />
      {/* </a> */}
    </React.Fragment>
  );
};

export default Counter;
